import React, {useState, useRef, useEffect} from "react";
import {Button} from 'primereact/button';
import axios from "axios";
import {Toast} from "primereact/toast";
import {Card} from 'primereact/card';
import {Dialog} from "primereact/dialog";
import {Link} from "react-router-dom";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {InputText} from "primereact/inputtext";
import * as management from "../../actions/management";
import * as auth from "../../actions/auth";
import connect from "react-redux/lib/connect/connect";


const SSSList = props => {
    const toast = useRef(null);
    const [faqList, setFaqList] = useState([]);
    const [sssDeleteDialog, setSssDeleteDialog] = useState(false);
    const [sssID, setSssID] = useState(null);
    const sss_list_role = !!localStorage.getItem('sss_list');
    const [textDetailPopupVisible, setTextDetailPopupVisible] = useState(false);
    const [textDetailText, setTextDetailText] = useState(null);
    const [textDetailHeader, setTextDetailHeader] = useState(null);
    const [globalFilter1, setGlobalFilter1] = useState('');
    const sss_add_role = !!localStorage.getItem('sss_add');


    useEffect(() => {

        getSSSList()


    }, []); //Buradaki dizi içine yazılan değer, değişince useeffecti çalıştır.

    const customer1TableHeader = (
        <div className="table-header" align="right">

            <span className="p-input-icon-left">
                <i className="pi pi-search"/>
                <InputText value={globalFilter1} onChange={(e) => setGlobalFilter1(e.target.value)}
                           placeholder="Genel Arama"/>
            </span>
        </div>
    );
    const showSuccess = (message) => {
        toast.current.show({severity: 'success', summary: message, detail: message, life: 3000});
    }

    const showError = (message) => {
        toast.current.show({
            severity: 'error',
            summary: message,
            detail: message,
            life: 3000
        });
    }


    const getSSSList = () => {
        const token = localStorage.getItem("token");
        const headers = {"Authorization": "Token " + token}
        axios.get('/api/sss/', {"headers": headers})
            .then(res => {
                setFaqList(res.data.faq_list)
            })
            .then(res => {
                if (res.status < 500) {
                    return res.json().then(data => {
                        return {status: res.status, data};
                    })
                } else {
                    //console.log("Server Error!");
                    throw res;
                }
            })
            .then(res => {
                if (res.status === 401) {
                    props.loadUser();
                    throw res.data;
                } else if (res.status === 403) {
                    throw res.data;
                }
            })
    }

    const renderFooter = () => {
        return (
            <div>

                <Button label="Hayır" icon="pi pi-times" onClick={() => setSssDeleteDialog(false)}
                        className="p-button-text"/>
                <Button label="Evet" icon="pi pi-check" onClick={() => deleteCip(sssID)} autoFocus/>
            </div>
        );
    }
    const deleteRow = (faq_id) => {


        setSssDeleteDialog(true)
        setSssID(faq_id)


    }
    const deleteCip = (faq_id) => {
        const token = localStorage.getItem("token");
        const headers = {"Authorization": "Token " + token}
        axios.delete('api/sss' + `/${faq_id}/`, {"headers": headers})
            .then(res => {
                const data = res.data
                if (data.result) {
                    showSuccess(data.message);

                } else {
                    showError(data.message);
                }
                getSSSList()

                setSssDeleteDialog(false)
                setSssID(null)


            });


    };
    const selectPages = (faq_id) => {
        const url = "/sssAdd/" + faq_id + "/";
        window.location.hash = url
    }


    const actionTemplate = (rowData) => {
        return <div>
            {sss_add_role ?
                <div>
             <Button tooltip="Düzenle" icon="pi pi-pencil" className="p-button-sm p-button-warning"
                    onClick={() => selectPages(rowData['faq_id'])}
                    // style={{display: sss_add_role ? 'block' : 'none'}}
                    tooltipOptions={{position: 'bottom', mouseTrack: true, mouseTrackTop: 15}}/>
            <Button tooltip="Sil" icon="pi pi-trash" className="p-button-sm p-button-secondary p-ml-2"
                    onClick={() => deleteRow(rowData['faq_id'])}
                    // style={{display: sss_add_role ? 'block' : 'none'}}
                    tooltipOptions={{position: 'bottom', mouseTrack: true, mouseTrackTop: 15}}/> </div> :
                <div></div>
            }




        </div>;
    }
    const header = (
        <img alt="Card" style={{width: '50px'}}
             src="https://www.pngitem.com/pimgs/m/463-4637103_icon-info-transparent-svg-new-icon-hd-png.png"/>
    );
    const textDetail = (fulltext, text_header) => {
        setTextDetailPopupVisible(true);
        setTextDetailText(fulltext);
        setTextDetailHeader(text_header);
    }
    const textSummary = (str, header) => {
        var regex = /<[^>]*(>|$)|&nbsp;|&zwnj;|&raquo;|&laquo;|&gt;/g
        var result = str.replace(regex, "");
        if (result.length > 50) {
            return <div>
                {result.substring(0, 100)}...
                <Link onClick={() => textDetail(result, header)} to="#"> Devamını Gör </Link>
            </div>
        } else {
            return <p dangerouslySetInnerHTML={{__html: str}}/>
        }
    }
    const logDescription = rowData => {
        return <div>
            {/*<p dangerouslySetInnerHTML={{__html:rowData['faq_answer']}} />*/}
            {textSummary(rowData['faq_answer'], rowData['faq_id'])}
        </div>
    }


    const cardItems = (item) => (
        <div className="p-mb-5 p-mr-5">


            <Card title={item.faq_question} subTitle={item.md_name} style={{width: '25em'}}
                  footer={actionTemplate(item)}
            >
                <p className="m-0" style={{lineHeight: '1.5'}}>{logDescription(item)}</p>
            </Card>
            <div className="content-section implementation">
                <Dialog header={textDetailHeader}
                        visible={textDetailPopupVisible}
                        style={{width: '50vw'}}
                        modal={true}
                        onHide={(e) => setTextDetailPopupVisible(false)}>
                    <p>{textDetailText}</p>
                </Dialog>
            </div>
        </div>


    )


    const createNewContent = () => {
        window.location.hash = '/sssAdd'
    }

    if (sss_list_role) {
        return (

            <div>
                <Button label="Yeni SSS  Ekle" icon="pi pi-plus" className="p-button-success p-mb-5"
                        onClick={createNewContent} style={{width: '150px', height: '35px',display: sss_add_role ? 'block' : 'none'}}/>


                <Toast ref={toast}/>
                {/*<DataView value={faqList} layout={'grid'}*/}
                {/*          itemTemplate={cardItems} paginator rows={12} emptyMessage="Kayıt Bulunamadı."*/}

                {/*/>*/}
                <div className="datatable-responsive-demo">

                    <div className="card">
                        <h5><b>Sıkça Sorulan Sorular</b></h5>
                        <p>Sayfalandırma, sıralama ve filtreleme </p>
                        <DataTable
                            responsive={true}
                            value={faqList}
                            paginator
                            resizableColumns={true}
                            className="p-datatable-responsive-demo"
                            rows={10} dataKey="id"
                            rowHover globalFilter={globalFilter1} emptyMessage="Kayıt Bulunamadı."
                            header={customer1TableHeader}

                        >
                            {/*<Column selectionMode="multiple" headerStyle={{width: '3rem'}}></Column>*/}
                            <Column
                                field={'faq_id'}
                                header="No"
                                style={{fontWeight: 'bold', textAlign: 'left', width: '5.5em'}}
                                sortable


                            />
                            <Column
                                field={'faq_question'}
                                header="Soru"
                                filter
                                style={{textAlign: 'center', fontWeight: 'bold'}}


                            />
                            <Column field={'faq_answer'}
                                    body={logDescription}
                                    header="Cevap"
                                    filter
                                    style={{textAlign: 'center'}}

                            />
                            <Column
                                field={'md_name'}
                                header="Modül"
                                filter
                                style={{textAlign: 'center', fontWeight: 'bold'}}
                                sortable


                            />


                            <Column
                                header="İşlevler"
                                body={actionTemplate}
                                style={{fontWeight: 'bold', width: '7.5em'}}
                            />


                        </DataTable>
                    </div>
                </div>
                <Dialog header="UYARI" visible={sssDeleteDialog}
                        style={{width: '20%'}}
                        footer={renderFooter()}

                        onHide={() => setSssDeleteDialog(false)}>
                    <div className="confirmation-content">
                        <i className="pi pi-exclamation-triangle p-mr-3" style={{fontSize: '2rem'}}/>
                        <span>Silmek İstediğinizden Emin Misiniz?</span>
                    </div>


                </Dialog>
                <div className="content-section implementation">
                    <Dialog header={textDetailHeader}
                            visible={textDetailPopupVisible}
                            style={{width: '50vw'}}
                            modal={true}
                            onHide={(e) => setTextDetailPopupVisible(false)}>
                        <p>{textDetailText}</p>
                    </Dialog>
                </div>


            </div>

        )
    } else {
        return (
            window.location.hash = "/notfound"
            // <Redirect to="#notfound"/>
        )
    }

}
const mapStateToProps = state => {
    return {
        user: state.auth.user,
        management: state.management,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        putMethod: (data, url, type) => {
            return dispatch(management.putMethod(data, url, type));
        },
        postMethod: (data, url, type) => {
            return dispatch(management.postMethod(data, url, type));
        },
        deleteMethod: (data, url, type) => {
            return dispatch(management.deleteMethod(data, url, type));
        },
        logout: () => dispatch(auth.logout()),
        loadUser: () => {
            return dispatch(auth.loadUser());
        },

    }
};

export default connect(mapStateToProps, mapDispatchToProps)(SSSList);



// WEBPACK FOOTER //
// ./src/pages/modulemanagement/SSSList.jsx